import analytics from '../index';

async function trackValidationErrors(fieldId, fieldName) {
  const validationErrorPayload = {
    field_id:   fieldId,
    field_name: fieldName,
  };

  await analytics.track('validationError', validationErrorPayload);
}

function handleBlurEvent(e) {
  const { target } = e;

  const { id, name, className } = target;

  if (className.includes('error')) {
    trackValidationErrors(id, name);
  }
}

function addValidationErrorListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].addEventListener('blur', handleBlurEvent);
  }
}

function removeValidationErrorListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].removeEventListener('blur', handleBlurEvent);
  }
}

export {
  addValidationErrorListeners,
  removeValidationErrorListeners,
  handleBlurEvent,
  trackValidationErrors,
};
